var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bgwall",style:({'background-color':_vm.color})},[_vm._t("row1"),_vm._t("row2")],2)}
var staticRenderFns = []

export { render, staticRenderFns }